import { useMemo } from "react";
import { useAppSelector } from "./useAppSelector";

/**
 * thoi_gian_dang_ky được Worker ghi theo UTC (evt.ReservedAt) nhưng serialize KHÔNG có hậu tố 'Z'
 * (DB DATETIME2 → Dapper đọc Kind=Unspecified). new Date() mặc định hiểu LOCAL → lệch +7h ở VN.
 * Ép parse UTC để khớp mốc reaper (cũng dùng UtcNow). Trả NaN nếu chuỗi rỗng.
 */
export const parseUtcMs = (iso?: string): number => {
    if (!iso) return NaN;
    const hasTz = /[zZ]$|[+-]\d\d:?\d\d$/.test(iso);
    return new Date(hasTz ? iso : iso + "Z").getTime();
};

/**
 * Mốc tự huỷ (epoch ms) nếu SV không bấm "Lưu dữ liệu": lần đăng ký GẦN NHẤT (chưa chốt) + N phút.
 * N = financial.so_phut_huy_neu_khong_luu (chỉ khi đợt bật yeu_cau_chot_du_lieu). Trả null khi
 * KHÔNG áp dụng: tắt cờ / N=0 / chưa có lớp Confirmed chưa chốt nào. Mốc reset khi myList đổi
 * (đăng ký thêm → lần ĐK gần nhất mới → mốc mới) — khớp đúng hành vi reaper backend.
 *
 * Tự đọc redux (registration.myList + financial.data) → mọi trang/biến thể (desktop, mobile, /my)
 * dùng chung 1 nguồn, không lặp logic.
 */
export const useSaveDeadline = (): number | null => {
    const myList = useAppSelector(s => s.registration.myList);
    const financial = useAppSelector(s => s.financial.data);
    return useMemo(() => {
        // CHỈ áp dụng khi đợt BẬT yêu cầu "Lưu dữ liệu" (yeu_cau_chot_du_lieu === true) VÀ có hạn
        // tự huỷ > 0 — khớp đúng điều kiện reaper backend. financial null/chưa nạp → ẩn (không đoán bật).
        const requireChot = financial?.yeu_cau_chot_du_lieu === true;
        const soPhut = financial?.so_phut_huy_neu_khong_luu ?? 0;
        if (!requireChot || soPhut <= 0) return null;
        const active = myList.filter(r => r.trang_thai === 1 && !r.isChotDuLieu);
        if (active.length === 0) return null;
        const lastReg = active.reduce((mx, r) => {
            const t = parseUtcMs(r.thoi_gian_dang_ky);
            return Number.isFinite(t) && t > mx ? t : mx;
        }, 0);
        if (lastReg <= 0) return null;
        return lastReg + soPhut * 60_000;
    }, [myList, financial]);
};
